import React from "react";
import Modal from "react-bootstrap/Modal";


const FinalRateInfo = ({ onClose, item, payrollViewData }) => {
    // console.log("🚀 ~ RateInfo ~ payrollViewData:", payrollViewData)
    return (
        <Modal
            show={onClose}
            onHide={onClose}
            className="ftcModalPopup"
            size={"md"}
        >
            <Modal.Header closeButton>
                <Modal.Title>Final Payroll: Per Hour Rate Info: {payrollViewData?.userId?.name}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="careNotesPopup">
                <div className="row">
                    {
                        payrollViewData?.userId?.modelId?.contractedHours?.contractedHours !== '' && (
                            <>
                                <div className="col-md-12">
                                    <p><strong>Contract:</strong>
                                        {payrollViewData?.userId?.modelId?.contractedHours?.contractedHours} hours </p>
                                </div>

                                <div className="col-md-6">
                                    <p><strong>Contracted Hours Rate:</strong>
                                        £{payrollViewData?.userId?.modelId?.contractedHours?.perHourRate || 0}/hour </p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Over Night Sleep Rate:</strong>
                                        £{payrollViewData?.userId?.modelId?.contractedHours?.overNightSleepRate || 0}/hour </p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Enhanced Rate:</strong>
                                        £{payrollViewData?.userId?.modelId?.contractedHours?.enhancedRate || 0}/hour </p>
                                </div>

                                <div className="col-md-6">
                                    <p><strong>Training Rate:</strong>
                                        £{payrollViewData?.userId?.modelId?.contractedHours?.trainingRate || 0}/hour </p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Overtime Rate:</strong>
                                        £{payrollViewData?.userId?.modelId?.contractedHours?.overtimeRate || 0}/hour</p>
                                </div>

                            </>
                        )
                    }
                </div>
            </Modal.Body>

        </Modal>
    );
};

export default FinalRateInfo;